import { scanPickBin } from './api';

// Returns the bin-scan result when `barcode` is a location (not the expected SKU), else null.
export async function recordBinScan(pickListId, index, barcode, item) {
  const code = String(barcode || '').trim();
  if (!code || typeof navigator === 'undefined' || !navigator.onLine) return null;
  if ([item?.sku_code, item?.sku_barcode, item?.variant_code].filter(Boolean).includes(code)) return null;
  try {
    const r = await scanPickBin(pickListId, index, code);
    return r.data?.is_bin ? r.data : null;
  } catch (_) {
    return null;
  }
}

export const binScanMessage = (r) => (r.matches_planned || !r.planned_location_code
  ? `Bin ${r.location_code} confirmed — now scan the item`
  : `Bin ${r.location_code} recorded (planned ${r.planned_location_code}) — now scan the item`);
